import { render, staticRenderFns } from "./TasksTableGroup.vue?vue&type=template&id=5c494729&scoped=true&"
import script from "./TasksTableGroup.vue?vue&type=script&lang=js&"
export * from "./TasksTableGroup.vue?vue&type=script&lang=js&"
import style0 from "./TasksTableGroup.vue?vue&type=style&index=0&id=5c494729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c494729",
  null
  
)

export default component.exports